import BtnGroup from './containers/btn_group/BtnGroup';
import RuleTabel from './containers/rule_table/TablePage';
import { useState } from 'react';
import './index.less';
import React, { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'dva';
import { Divider, Form, message } from 'antd';
import {
  handleFormData,
  hasUndefInObj,
  selectChangeIsRequired,
} from '../../../utils/breUtils';

const RuleEngine = (props) => {
  const { id, name } = props.location.query;
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [saveLoading, setSaveLoading] = useState(false);

  // 发起请求
  const fetchData = useCallback(() => {
    dispatch({
      type: 'tvfCondition/getTvfRuleList',
      payload: {
        values: {
          fieldId: id,
        },
      },
      callback: () => {
        form.resetFields(); //再次展开Form的列表首先清空
      },
    });
  }, [dispatch, form, id]);
  useEffect(() => {
    fetchData();
  }, [fetchData]);
  //获取rule原来的数据
  const data = useSelector((state) => state.tvfCondition.getTvfRuleList);
  const ruleList = data;

  const onFinish = () => {
    setSaveLoading(true);
    const oldData = JSON.parse(JSON.stringify(ruleList));
    // (oldData || []).forEach((item) => (item['fieldId'] = id));
    const formVal = form.getFieldsValue();

    if (selectChangeIsRequired(formVal)) {
      setSaveLoading(false);
      message.warning('请填写完整');
      return;
    }
    const newdata = handleFormData(oldData, formVal);

    //对数据进行判空
    let isRequire = false;
    (newdata || []).forEach((item) => {
      if (String(item.id).includes('null')) {
        delete item.id;
      }
      if (item['variableType1'] === 'SYSTEM') {
        item['element1'] = item['element1'] && item['element1'][1];
      }
      if (item['variableType2'] === 'SYSTEM') {
        item['element2'] = item['element2'] && item['element2'][1];
      }

      isRequire = hasUndefInObj(item, undefined);
    });
    if (isRequire) {
      setSaveLoading(false);
      message.warning('请填写完整');
      return;
    }
    //保存接口
    dispatch({
      type: 'tvfCondition/saveTvfRuleList',
      payload: {
        values: {
          fieldId: id,
          variableInputList: newdata,
        },
      },
      callback: (d) => {
        setSaveLoading(false);
        const { code } = d || {};
        if (code) {
          message.error('保存失败');
        } else {
          message.success('保存成功');
        }
        fetchData();
      },
    });
  };
  const handleBtnCancel = () => {
    fetchData();
  };

  return (
    <div className="re">
      <div className="contain">
        <Form form={form} name="rule">
          <BtnGroup
            {...props}
            id={id}
            name={name}
            handleSave={onFinish}
            handleCancel={handleBtnCancel}
          />
          <Divider />
          <RuleTabel
            {...props}
            name={name}
            id={id}
            fetchData={fetchData}
            form={form}
            saveLoading={saveLoading}
          />
        </Form>
      </div>
    </div>
  );
};

export default RuleEngine;
